import { render, staticRenderFns } from "./StudentCapacity.vue?vue&type=template&id=2af82403&scoped=true"
import script from "./StudentCapacity.vue?vue&type=script&lang=js"
export * from "./StudentCapacity.vue?vue&type=script&lang=js"
import style0 from "./StudentCapacity.vue?vue&type=style&index=0&id=2af82403&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af82403",
  null
  
)

export default component.exports